import { render, staticRenderFns } from "./GLCodeMappingListingNew.vue?vue&type=template&id=38a48e60"
import script from "./GLCodeMappingListingNew.vue?vue&type=script&lang=js"
export * from "./GLCodeMappingListingNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports